<div [formGroup]="group">
    <h2 *ngIf="config.title">{{ config.title }}</h2>
    <div class="col-to-row-s-mb age-traveller">
        <span class="field-sep" *ngIf="hasChildInfant()">{{ Yii.t('wui-shared-js', 'Age ') }}</span>
        <span *ngFor="let traveller of group.controls; let i = index" [formGroupName]="i">
            <ng-container *ngIf="getType(i) != 'adult'">
                <number-field class="field-sep fix-width-1" [group]="traveller" controlName="age"
                    [labelLeft]="getTranslation(i) + ' ' + getTypeIndex(i)"></number-field>
            </ng-container>
        </span>
    </div>

</div>